module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/cornell-university-8218cfa0ecbff58abf4dac7b65d2575c.png";